module.exports = __webpack_public_path__ + "img/342-a379ee.png";